module.exports = __webpack_public_path__ + "img/clock.e63cb2c7.svg";